













// @ is an alias to /src
import { Component } from "vue-property-decorator";
import HacoCommon from "../HacoCommon";
import Dialog from "@/components/Dialog.vue";
import ScenarioList from "@/components/ScenarioList.vue";
@Component({
  components: {
    Dialog,
    ScenarioList
  }
})
export default class Scenario extends HacoCommon {
  // put something
}
